import debounce from "lodash/debounce";
import isNumber from "lodash/isNumber";
import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { v4 as uuid } from "uuid";
import { TASK_RESULT_LIMIT } from "../constants";
import locale from "./taskResultLimitPanel.locale";
import ScrolledDropdown from "Components/scrolledDropdown";
import map from "lodash/map";
import styles from "./taskResultLimitPanel.module.css";
import classNames from "classnames";
function TaskResultLimitPanel(props) {
    const sliderContainerId = useMemo(() => `sliderContainer_${uuid()}`, []);
    const popoverRef = useRef(null);
    const [value, setValue] = useState(() => props.taskResultLimit);
    const [taskResultLimit, setTaskResultLimit] = useState(props.taskResultLimit);
    useEffect(() => {
        setValue(props.taskResultLimit);
        setTaskResultLimit(props.taskResultLimit);
    }, [props.taskResultLimit]);
    useEffect(() => {
        props.documentId &&
            !props.taskResultLimit &&
            props.onGetTaskResultLimit &&
            props.onGetTaskResultLimit(props.documentId);
    }, [props.documentId]);
    const handleTaskResultLimitChange = useCallback(debounce((val) => {
        var _a;
        if (!props.documentId || !isNumber(val))
            return;
        const limitValue = TASK_RESULT_LIMIT.STEPS[val];
        limitValue && ((_a = props.onSaveTaskResultLimit) === null || _a === void 0 ? void 0 : _a.call(props, props.documentId, limitValue));
    }, 500), [props.documentId, props.onSaveTaskResultLimit]);
    const handleTaskResultLimitChanged = useCallback((val) => {
        var _a;
        setValue(val);
        const newLimit = TASK_RESULT_LIMIT.STEPS[val];
        setTaskResultLimit(newLimit);
        handleTaskResultLimitChange(val);
        (_a = popoverRef.current) === null || _a === void 0 ? void 0 : _a.instance.repaint();
    }, [handleTaskResultLimitChange]);
    const items = useMemo(() => map(TASK_RESULT_LIMIT.STEPS, item => ({
        value: item,
        label: item
    })), [TASK_RESULT_LIMIT.STEPS, taskResultLimit]);
    return (React.createElement(ScrolledDropdown, { items: items, onSelectedChanged: handleTaskResultLimitChanged, selectedKey: value, togglerMuteDefaultCaptionText: false, keySelector: item => item.value, textSelector: item => item.label, id: sliderContainerId, togglerClassName: classNames(styles.dropdown, "no-border btn-filled pt-0 pb-0"), togglerTitle: locale.TASK_RESULT_LIMIT, minWidth: 75, maxHeight: 200, togglerHeight: 32 }));
}
export default memo(TaskResultLimitPanel);
